/**
 * Convert answers + questions into API-friendly format
 *
 * @param {Array} questions
 * @param {Object} answers
 * @returns {Array}
 */
export function transformAnswersForApi(questions, answers) {
  return questions.map((q, index) => ({
    qno: index + 1,
    title: q.title,
    score: answers[q.id]?.score || 0
  }));
}
